import React from 'react';
import { Head, Link } from '@inertiajs/react';
import DashboardLayout from '../../components/DashboardLayout';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const Index: React.FC = () => {
  return (
    <DashboardLayout>
      <Head title="Admin Panel" />

      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Admin Panel</h1>
          <p className="mt-1 text-sm text-gray-400">
            Manage administrative functions and data imports.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle>Legal Documents</CardTitle>
              <CardDescription>Manage privacy policy and terms of service.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <Link href="/admin/legal_documents">
                <Button className="w-full">Manage Documents</Button>
              </Link>
            </CardContent>
          </Card>

        </div>
      </div>
    </DashboardLayout>
  );
};

export default Index;